(() => {
  'use strict';

  const DISCOUNT_CODES = {
    // Coduri ACTIVE in Shopify (aprobate George 2026-08-21), scopate pe colectia
    // multi-builder-pungi-intern cu prag minim de cantitate 5/10/20.
    // Redirectul /discount/<cod>?redirect=/checkout aplica automat tierul cel mai mare atins;
    // un cod dezactivat nu blocheaza checkoutul (flow degradeaza la pret intreg).
    5: 'PACHET5',
    10: 'PACHET10',
    20: 'PACHET20'
  };

  const CAMPAIGN_ATTRIBUTES = {
    '_funnel_slug': 'shopify-back-to-school',
    '_campaign': 'back-to-school-2026',
    '_landing_variant': 'back-to-school',
    '_bundle_id': 'multi-builder',
    '_bundle_name': 'Back to School'
  };

  function parseJson(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (error) { console.error('[cj-bts] JSON parse failed', id, error); return null; }
  }

  let S = {};
  // Formatul monetar NU se ghiceste: sectiunea trimite 1111,11 randat cu filtrul `money`
  // al pietei curente, iar de acolo deducem prefix/sufix si separatorii. Asa arata cifrele
  // din cos exact ca cele randate de Shopify pe aceeasi pagina, in orice piata.
  let MONEY = { currency: 'RON', prefix: '', suffix: ' lei', dec: ',', thou: '.', decimals: 2 };

  function setupMoney(currency, sample) {
    MONEY.currency = currency || '';
    if (!sample) return;
    const first = sample.search(/[0-9]/);
    if (first < 0) return;
    let last = first;
    for (let i = sample.length - 1; i >= 0; i -= 1) {
      if (sample[i] >= '0' && sample[i] <= '9') { last = i; break; }
    }
    const body = sample.slice(first, last + 1);
    const seps = body.replace(/[0-9]/g, '');
    const tail = body.match(/([.,])([0-9]{2})$/);
    const dec = tail ? tail[1] : '';
    const others = dec ? seps.split(dec).join('') : seps;
    MONEY.prefix = sample.slice(0, first);
    MONEY.suffix = sample.slice(last + 1);
    MONEY.dec = dec || ',';
    MONEY.thou = others ? others[others.length - 1] : '';
    MONEY.decimals = dec ? 2 : 0;
  }

  function fmtAmount(value) {
    const fixed = Math.abs(Number(value || 0)).toFixed(MONEY.decimals);
    const parts = fixed.split('.');
    let whole = parts[0];
    if (MONEY.thou) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.thou);
    return MONEY.decimals ? whole + MONEY.dec + parts[1] : whole;
  }

  function fmtPrice(value) {
    return MONEY.prefix + fmtAmount(value) + MONEY.suffix;
  }

  // Pretul taiat: la monedele cu simbol in fata ("€4,95") simbolul trebuie pastrat, altfel
  // cifra taiata se lipeste de simbolul pretului redus. La cele cu sufix ramane doar cifra.
  function fmtStrike(value) {
    return MONEY.prefix ? fmtPrice(value) : fmtAmount(value);
  }

  function t(key, vars) {
    let out = S[key] == null ? '' : String(S[key]);
    if (vars) Object.keys(vars).forEach(function(name) {
      out = out.split('%' + name + '%').join(String(vars[name]));
    });
    return out;
  }

  function animateValue(el, from, to, duration) {
    if (!el) return;
    if (from === to) {
      el.textContent = fmtPrice(to);
      return;
    }
    let start = null;
    const diff = to - from;
    function step(ts) {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = fmtPrice(from + diff * eased);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function tasteScale(product) {
    const d = product.taste;
    if (!d) return '';
    function dots(n) {
      return new Array(5).fill(0).map(function(_, i) {
        return '<span style="display:inline-block;width:9px;height:9px;border-radius:50%;margin-left:3px;background:' + (i < n ? '#7A1F1F' : '#E0D6CC') + ';"></span>';
      }).join('');
    }
    function row(label, n) {
      return '<div style="display:flex;align-items:center;justify-content:space-between;margin:3px 0;"><span>' + label + '</span><span style="white-space:nowrap;">' + dots(n) + '</span></div>';
    }
    return '<div class="mb-product__taste" style="padding:2px 14px 6px;font-size:11px;color:#5b5048;line-height:1.2;overflow-wrap:anywhere;word-break:break-word;min-width:0;">'
      + row(t('taste_aroma'), d.carne)
      + row(t('taste_salt'), d.sarat)
      + row(t('taste_spice'), d.condimentat)
      + '<div style="margin-top:5px;"><div style="display:flex;justify-content:space-between;font-size:10px;color:#8a8078;margin-bottom:3px;"><span>' + t('taste_soft') + '</span><span>' + t('taste_crispy') + '</span></div><div style="position:relative;height:6px;border-radius:3px;background:linear-gradient(90deg,#E8D9C5,#7A1F1F);"><div style="position:absolute;top:-2px;left:calc(' + d.textura + '% - 5px);width:10px;height:10px;border-radius:50%;background:#fff;border:2px solid #7A1F1F;box-shadow:0 1px 2px rgba(0,0,0,.2);"></div></div></div></div>';
  }

  function resolveProductMap(sectionId) {
    const inlineMap = parseJson('cj-mb-product-map-' + sectionId);
    if (inlineMap && typeof inlineMap === 'object') return inlineMap;
    if (window.CJ_MB_PRODUCT_MAP && typeof window.CJ_MB_PRODUCT_MAP === 'object') return window.CJ_MB_PRODUCT_MAP;
    return {};
  }

  function getDiscountRedirect(qty, checkoutUrl, rootUrl) {
    // Prefixul de piata/limba trebuie pastrat, altfel /discount pierde contextul.
    let base = rootUrl && rootUrl !== '/' ? rootUrl : '';
    if (base.slice(-1) === '/') base = base.slice(0, -1);
    const target = checkoutUrl || (base + '/checkout');
    let code = null;
    if (qty >= 20) code = DISCOUNT_CODES[20];
    else if (qty >= 10) code = DISCOUNT_CODES[10];
    else if (qty >= 5) code = DISCOUNT_CODES[5];
    if (!code) return target;
    return base + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
  }

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const config = parseJson('cj-mb-config-' + sectionId);
    const products = parseJson('cj-mb-products-' + sectionId) || [];
    const presets = parseJson('cj-mb-presets-' + sectionId) || {};
    if (!config || !products.length) return;

    S = parseJson('cj-mb-strings-' + sectionId) || {};
    setupMoney(config.currency, config.moneySample);
    const shipMode = config.shipMode || 'ro';

    const productMap = resolveProductMap(sectionId);
    const state = {};
    products.forEach(function(product) { state[product.sku] = 0; });
    const maxQty = Number(config.maxQty || 20);
    const celebratedTiers = new Set([5]);
    const productsGrid = root.querySelector('[data-products-grid]');
    const cart = root.querySelector('[data-cart]');
    const cartItems = root.querySelector('[data-cart-items]');
    const recapItems = root.querySelector('[data-recap-items]');
    const tierCards = Array.from(root.querySelectorAll('.mb-tier-card'));
    const presetButtons = Array.from(root.querySelectorAll('.mb-preset'));
    const checkoutButtons = Array.from(root.querySelectorAll('[data-checkout]'));
    const submitErrors = Array.from(root.querySelectorAll('[data-submit-error]'));
    function setSubmitError(message) {
      submitErrors.forEach(function(node) {
        node.textContent = message || '';
        node.classList.toggle('is-visible', Boolean(message));
      });
    }
    const tierFill = root.querySelector('[data-tier-fill]');
    const tierLabel = root.querySelector('[data-tier-label]');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyQty = root.querySelector('[data-sticky-qty]');
    const stickyBadge = root.querySelector('[data-sticky-badge]');
    const stickyTotal = root.querySelector('[data-sticky-total]');
    const stickyCta = root.querySelector('[data-sticky-cta]');
    const nativeCheckout = root.querySelector('[data-native-checkout]');
    const builderSection = root.querySelector('.mb-builder-section');
    const heroSection = root.querySelector('.mb-hero');
    const toastEl = root.querySelector('[data-toast]');
    const progressSteps = Array.from(root.querySelectorAll('.mb-progress__step'));
    const progressLines = Array.from(root.querySelectorAll('[data-progress-line]'));
    const ui = {
      subtotal: root.querySelector('[data-subtotal]'),
      discountRow: root.querySelector('[data-discount-row]'),
      discountPct: root.querySelector('[data-discount-pct]'),
      discountAmount: root.querySelector('[data-discount-amount]'),
      shipping: root.querySelector('[data-shipping]'),
      total: root.querySelector('[data-total]'),
      savings: root.querySelector('[data-savings]'),
      savingsAmount: root.querySelector('[data-savings-amount]'),
      checkoutSubtotal: root.querySelector('[data-checkout-subtotal]'),
      checkoutDiscountRow: root.querySelector('[data-checkout-discount-row]'),
      checkoutDiscount: root.querySelector('[data-checkout-discount]'),
      checkoutShipping: root.querySelector('[data-checkout-shipping]'),
      checkoutTotal: root.querySelector('[data-checkout-total]'),
      recapSubtotal: root.querySelector('[data-recap-subtotal]'),
      recapDiscountRow: root.querySelector('[data-recap-discount-row]'),
      recapDiscount: root.querySelector('[data-recap-discount]'),
      recapShipping: root.querySelector('[data-recap-shipping]'),
      recapTotal: root.querySelector('[data-recap-total]')
    };
    let prevCartSub = 0;
    let prevCartTotal = 0;
    let prevStickyTotal = 0;
    let prevStickyTier = 0;
    let pastHero = false;
    let reachedCheckout = false;

    productsGrid.innerHTML = products.map(function(product, index) {
      const badges = (product.badges || []).map(function(badge, i) {
        const style = product.badge_styles && product.badge_styles[i] ? ' style="' + product.badge_styles[i] + '"' : '';
        return '<span class="mb-badge"' + style + '>' + badge + '</span>';
      }).join('');
      return '<div class="mb-product" data-sku="' + product.sku + '" data-price="' + product.price + '" style="animation-delay:' + (index * 0.04) + 's">'
        + '<div class="mb-product__img"><img src="' + product.image + '" alt="' + product.name + '"></div>'
        + '<div class="mb-product__info"><h3>' + product.name + '</h3><span class="mb-product__macros">' + product.weight + ' · ' + product.protein + '</span><span class="mb-product__unit-price">' + fmtPrice(product.price) + ' ' + t('unit_suffix') + '</span></div>'
        + tasteScale(product)
        + '<div class="mb-product__stepper"><button class="mb-stepper__btn mb-stepper__minus" type="button" data-action="minus" data-sku="' + product.sku + '" disabled>−</button><span class="mb-stepper__qty" data-qty-display="' + product.sku + '">0</span><button class="mb-stepper__btn mb-stepper__plus" type="button" data-action="plus" data-sku="' + product.sku + '">+</button></div>'
        + '<div class="mb-product__badges">' + badges + '</div>'
        + '<div class="mb-product__feedback"><span class="mb-product__subtotal-val"></span><span class="mb-product__tier-badge"></span></div>'
        + '</div>';
    }).join('');

    function setProgressStep(step) {
      progressSteps.forEach(function(node) {
        const n = Number(node.dataset.navStep);
        node.classList.remove('is-current', 'is-done');
        if (n < step) node.classList.add('is-done');
        if (n === step) node.classList.add('is-current');
      });
      progressLines.forEach(function(line, index) { line.classList.toggle('is-filled', step > index + 1); });
    }

    function getTotalQty() {
      return Object.values(state).reduce(function(sum, value) { return sum + value; }, 0);
    }

    function getSubtotal() {
      return products.reduce(function(sum, product) { return sum + (state[product.sku] * Number(product.price)); }, 0);
    }

    function getTier(qty) {
      if (qty >= 20) return { pct: 30, frac: 0.30, progress: 100, status: t('st_tier20') };
      if (qty >= 10) return { pct: 15, frac: 0.15, progress: 66, status: t('st_tier10', { n: 20 - qty }) };
      if (qty >= 5) return { pct: 10, frac: 0.10, progress: 33, status: t('st_tier5', { n: 10 - qty }) };
      if (qty > 0) return { pct: 0, frac: 0, progress: (qty / 5) * 25, status: t('st_tier0', { n: 5 - qty }) };
      return { pct: 0, frac: 0, progress: 0, status: t('st_none') };
    }

    function selectedItems() {
      return products.filter(function(product) { return state[product.sku] > 0; }).map(function(product) {
        return Object.assign({}, product, { quantity: state[product.sku], map: productMap[product.map_key] || null });
      });
    }

    function showToast(message) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.classList.add('is-show');
      setTimeout(function() { toastEl.classList.remove('is-show'); }, 2500);
    }

    function fireConfetti() {
      const container = document.createElement('div');
      container.className = 'mb-confetti-container';
      const colors = ['#C9A961', '#7A1F1F', '#D4A853', '#4A5D3A', '#F5EDE0', '#E8C170'];
      for (let i = 0; i < 30; i += 1) {
        const particle = document.createElement('div');
        particle.className = 'mb-confetti';
        particle.style.left = (Math.random() * 100) + '%';
        particle.style.top = '-10px';
        particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        particle.style.animationDelay = (Math.random() * 0.6) + 's';
        particle.style.animationDuration = (1.5 + Math.random()) + 's';
        particle.style.width = (5 + Math.random() * 6) + 'px';
        particle.style.height = particle.style.width;
        container.appendChild(particle);
      }
      root.appendChild(container);
      setTimeout(function() { container.remove(); }, 3000);
    }

    function updateStickyBar(qty) {
      const shouldShow = qty >= 1 && pastHero && !reachedCheckout && window.innerWidth < 768;
      if (stickyBar) stickyBar.classList.toggle('is-visible', shouldShow);
    }

    function renderCart(items, tier) {
      if (!items.length) {
        const emptySku = S.empty_sku || 'beef';
        const emptyProduct = S.empty_product || '';
        cartItems.innerHTML = '<div class="mb-cart__empty"><b>' + t('cart_empty_title') + '</b><span>'
          + t('cart_empty_hint1', { product: emptyProduct }) + '</span><button class="mb-empty-cta" type="button" data-add-sku="'
          + emptySku + '">' + t('cart_empty_cta', { product: emptyProduct }) + '</button><span>'
          + t('cart_empty_hint2') + '</span></div>';
        recapItems.innerHTML = '<div class="mb-recap__empty">' + t('recap_empty') + '</div>';
      } else {
        cartItems.innerHTML = items.map(function(item, index) {
          return '<div class="mb-cart__item" style="animation-delay:' + (index * 50) + 'ms"><img src="' + item.image + '" alt="' + item.name + '"><div class="mb-cart__item-info"><b>' + item.name + '</b><span class="mb-cart__item-meta">' + item.quantity + ' × ' + item.weight + '</span><span class="mb-cart__item-price">' + fmtPrice(item.price) + t('per_piece') + '</span></div><span class="mb-cart__item-total">' + fmtPrice(item.quantity * item.price) + '</span></div>';
        }).join('');
        recapItems.innerHTML = items.map(function(item) {
          return '<div class="mb-recap__item"><img src="' + item.image + '" alt=""><div class="mb-recap__item-name"><b>' + item.name + ' × ' + item.quantity + '</b><span>' + item.weight + '</span><span>' + fmtPrice(item.price) + ' ' + t('per_piece') + '</span></div><span>' + fmtPrice(item.quantity * item.price) + '</span></div>';
        }).join('');
      }
      products.forEach(function(product) {
        const row = productsGrid.querySelector('[data-sku="' + product.sku + '"]');
        if (!row) return;
        row.classList.toggle('has-qty', state[product.sku] > 0);
        const subtotalNode = row.querySelector('.mb-product__subtotal-val');
        const unitPriceNode = row.querySelector('.mb-product__unit-price');
        const badgeNode = row.querySelector('.mb-product__tier-badge');
        const minus = row.querySelector('[data-action="minus"]');
        const qtyNode = row.querySelector('[data-qty-display="' + product.sku + '"]');
        const qty = state[product.sku];
        const discountedUnit = Number((product.price * (1 - tier.frac)).toFixed(2));
        qtyNode.textContent = String(qty);
        minus.disabled = qty === 0;
        if (qty > 0) {
          subtotalNode.textContent = fmtPrice(qty * (tier.frac > 0 ? discountedUnit : product.price));
          badgeNode.textContent = tier.pct > 0 ? t('contributes', { p: tier.pct }) : '';
          if (tier.frac > 0) {
            unitPriceNode.innerHTML = '<s style="opacity:0.5;font-size:0.85em;margin-right:3px;">' + fmtStrike(product.price) + '</s> ' + fmtPrice(discountedUnit) + ' ' + t('unit_suffix');
          } else {
            unitPriceNode.textContent = fmtPrice(product.price) + ' ' + t('unit_suffix');
          }
        } else {
          subtotalNode.textContent = '';
          badgeNode.textContent = '';
          unitPriceNode.textContent = fmtPrice(product.price) + ' ' + t('unit_suffix');
        }
      });
    }

    function fmtShipping(shipping) {
      if (shipping === null) return shipMode === 'ro' ? '—' : t('ship_at_checkout');
      return shipping === 0 ? t('free_label') : fmtPrice(shipping);
    }

    function recompute() {
      const qty = getTotalQty();
      const subtotal = Number(getSubtotal().toFixed(2));
      const tier = getTier(qty);
      const items = selectedItems();
      const discount = Number(items.reduce(function(sum, item) {
        const unitDiscount = Math.floor(Number(item.price) * 100 * tier.frac) / 100;
        return sum + unitDiscount * item.quantity;
      }, 0).toFixed(2));
      const afterDiscount = Number((subtotal - discount).toFixed(2));
      // In afara pietei RO transportul il calculeaza Shopify la checkout: nu il inventam aici.
      const shipping = shipMode !== 'ro' || qty === 0
        ? null
        : (afterDiscount >= Number(config.freeShippingThreshold) ? 0 : Number(config.shipCost));
      const total = qty === 0 ? 0 : Number((afterDiscount + (shipping || 0)).toFixed(2));
      const savings = Number((discount + (shipping === 0 && qty > 0 ? Number(config.shipCost) : 0)).toFixed(2));
      tierCards.forEach(function(card) {
        const target = Number(card.dataset.tier);
        card.classList.remove('is-active', 'is-passed');
        if (qty >= target) {
          if ((target === 5 && qty < 10) || (target === 10 && qty < 20) || (target === 20 && qty >= 20)) card.classList.add('is-active');
          if ((target === 5 && qty >= 10) || (target === 10 && qty >= 20)) card.classList.add('is-passed');
        }
      });
      tierFill.style.width = tier.progress + '%';
      tierLabel.textContent = tier.status;
      cart.classList.toggle('is-empty', qty === 0);
      renderCart(items, tier);

      animateValue(ui.subtotal, prevCartSub, subtotal, 300);
      prevCartSub = subtotal;
      if (discount > 0) {
        ui.discountRow.hidden = false;
        ui.discountPct.textContent = String(tier.pct);
        ui.discountAmount.textContent = '−' + fmtPrice(discount);
      } else {
        ui.discountRow.hidden = true;
      }
      ui.shipping.textContent = fmtShipping(shipping);
      animateValue(ui.total, prevCartTotal, total, 300);
      prevCartTotal = total;
      ui.savings.hidden = savings <= 0;
      ui.savingsAmount.textContent = fmtPrice(savings);
      ui.checkoutSubtotal.textContent = fmtPrice(subtotal);
      ui.checkoutDiscountRow.hidden = discount <= 0;
      ui.checkoutDiscount.textContent = '−' + fmtPrice(discount);
      ui.checkoutShipping.textContent = fmtShipping(shipping);
      ui.checkoutTotal.textContent = fmtPrice(total);
      ui.recapSubtotal.textContent = fmtPrice(subtotal);
      ui.recapDiscountRow.hidden = discount <= 0;
      ui.recapDiscount.textContent = '−' + fmtPrice(discount);
      ui.recapShipping.textContent = fmtShipping(shipping);
      ui.recapTotal.textContent = fmtPrice(total);

      stickyQty.textContent = String(qty);
      animateValue(stickyTotal, prevStickyTotal, total, 300);
      prevStickyTotal = total;
      if (tier.pct > 0) {
        stickyBadge.hidden = false;
        stickyBadge.innerHTML = '−' + tier.pct + '%';
        if (tier.pct !== prevStickyTier) {
          stickyBadge.classList.remove('pulse');
          void stickyBadge.offsetWidth;
          stickyBadge.classList.add('pulse');
        }
      } else {
        stickyBadge.hidden = true;
      }
      prevStickyTier = tier.pct;
      checkoutButtons.forEach(function(button) {
        button.disabled = qty === 0;
        button.classList.toggle('opacity-50', qty === 0);
        button.classList.toggle('pointer-events-none', qty === 0);
        if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent;
        if (qty === 0) button.textContent = button.dataset.defaultLabel;
      });
      updateStickyBar(qty);
      setProgressStep(qty > 0 ? 2 : 1);

      [{threshold:5,msg:t('toast5'),confetti:false},{threshold:10,msg:t('toast10'),confetti:true},{threshold:20,msg:t('toast20'),confetti:true}].forEach(function(entry) {
        if (qty >= entry.threshold && !celebratedTiers.has(entry.threshold)) {
          celebratedTiers.add(entry.threshold);
          const card = tierCards.find(function(node) { return Number(node.dataset.tier) === entry.threshold; });
          if (card) {
            card.classList.remove('celebrate');
            void card.offsetWidth;
            card.classList.add('celebrate');
          }
          showToast(entry.msg);
          if (entry.confetti) fireConfetti();
        }
      });
    }

    productsGrid.addEventListener('click', function(event) {
      const button = event.target.closest('[data-action]');
      if (!button) return;
      const sku = button.dataset.sku;
      if (!(sku in state)) return;
      if (button.dataset.action === 'plus' && state[sku] < maxQty) state[sku] += 1;
      if (button.dataset.action === 'minus' && state[sku] > 0) state[sku] -= 1;
      recompute();
      const qtyNode = productsGrid.querySelector('[data-qty-display="' + sku + '"]');
      if (qtyNode) {
        qtyNode.classList.remove('pulse');
        void qtyNode.offsetWidth;
        qtyNode.classList.add('pulse');
      }
    });

    root.addEventListener('click', function(event) {
      const addBtn = event.target.closest('[data-add-sku]');
      if (addBtn) {
        const sku = addBtn.dataset.addSku;
        if (sku in state && state[sku] < maxQty) {
          state[sku] += 1;
          recompute();
        }
        return;
      }
      const preset = event.target.closest('[data-preset]');
      if (preset) {
        const next = presets[preset.dataset.preset];
        if (next && next.state) {
          Object.keys(state).forEach(function(sku) { state[sku] = 0; });
          Object.keys(next.state).forEach(function(sku) { if (sku in state) state[sku] = next.state[sku]; });
          presetButtons.forEach(function(button) { button.classList.toggle('is-active', button === preset); });
          recompute();
          if (builderSection) builderSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      const tierCard = event.target.closest('.mb-tier-card');
      if (tierCard) {
        const tier = Number(tierCard.dataset.tier);
        const key = tier === 5 ? 'starter' : (tier === 10 ? 'bestseller' : 'family');
        const next = presets[key];
        if (next && next.state) {
          Object.keys(state).forEach(function(sku) { state[sku] = 0; });
          Object.keys(next.state).forEach(function(sku) { if (sku in state) state[sku] = next.state[sku]; });
          recompute();
        }
      }
    });

    async function addToCartAndCheckout() {
      const items = selectedItems();
      if (!items.length) return;
      const missing = items.filter(function(item) { return !(item.map && item.map.variant_id); });
      if (missing.length) {
        setSubmitError(t('err_unavailable'));
        return;
      }
      setSubmitError('');
      checkoutButtons.forEach(function(button) {
        button.disabled = true;
        button.textContent = t('processing');
      });
      try {
        const updates = {};
        Object.values(productMap).forEach(function(entry) {
          const variantId = Number(entry.variant_id);
          if (variantId) updates[String(variantId)] = 0;
        });
        const emptyCampaignAttributes = {
          '_funnel_slug': '', '_campaign': '', '_landing_variant': '', '_bundle_id': '', '_bundle_name': ''
        };
        const checkoutAttributes = typeof CAMPAIGN_ATTRIBUTES === 'undefined' ? emptyCampaignAttributes : CAMPAIGN_ATTRIBUTES;
        let prepareResponse;
        for (let attempt = 0; attempt < 4; attempt += 1) {
          prepareResponse = await fetch(config.cartUpdateUrl || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates, attributes: checkoutAttributes })
          });
          if (prepareResponse.ok || !([408, 409, 425, 429].includes(prepareResponse.status) || prepareResponse.status >= 500)) break;
          await new Promise(function(resolve) { setTimeout(resolve, 1000 * Math.pow(2, attempt)); });
        }
        if (!prepareResponse.ok) throw new Error(t('err_prepare'));
        const payload = { items: items.map(function(item) { return { id: Number(item.map.variant_id), quantity: item.quantity }; }) };
        let response;
        for (let attempt = 0; attempt < 4; attempt += 1) {
          response = await fetch(config.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (response.ok || !([408, 409, 425, 429].includes(response.status) || response.status >= 500)) break;
          await new Promise(function(resolve) { setTimeout(resolve, 1000 * Math.pow(2, attempt)); });
        }
        if (!response.ok) {
          throw new Error(t('err_add'));
        }
        setProgressStep(3);
        window.location.assign(getDiscountRedirect(getTotalQty(), config.checkoutUrl, config.rootUrl));
      } catch (error) {
        setSubmitError(error.message);
        checkoutButtons.forEach(function(button) {
          button.disabled = false;
          button.textContent = button.dataset.defaultLabel || t('cta_checkout');
        });
      }
    }

    checkoutButtons.forEach(function(button) { button.addEventListener('click', addToCartAndCheckout); });
    if (stickyCta && nativeCheckout) stickyCta.addEventListener('click', function() { nativeCheckout.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    const revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.classList.contains('mb-rating-breakdown')) {
          entry.target.querySelectorAll('.mb-rating__bar-fill').forEach(function(bar) { bar.style.width = bar.dataset.width + '%'; });
        }
        revealObs.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('.mb-reveal, .mb-rating-breakdown').forEach(function(node) { revealObs.observe(node); });

    if (heroSection) {
      const heroObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateStickyBar(getTotalQty());
        });
      }, { threshold: 0 });
      heroObs.observe(heroSection);
    }
    if (nativeCheckout) {
      const checkoutObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          reachedCheckout = entry.isIntersecting;
          if (entry.isIntersecting) setProgressStep(3);
          updateStickyBar(getTotalQty());
        });
      }, { threshold: 0.15 });
      checkoutObs.observe(nativeCheckout);
    }

    window.addEventListener('scroll', function() {
      const nav = root.querySelector('.mb-nav');
      if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });

    if (presets.starter && presets.starter.state) {
      Object.keys(presets.starter.state).forEach(function(sku) { if (sku in state) state[sku] = presets.starter.state[sku]; });
    }
    presetButtons.forEach(function(button) { button.classList.toggle('is-active', button.dataset.preset === 'starter'); });
    recompute();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cj-mb[data-section-id]').forEach(function(root) { init(root); });
  });
})();
